
import { Component, Vue } from "vue-property-decorator";
import ActionTile from "@/app/components/common/ActionTile.vue";
import { Route } from "vue-router/types/router";
import router, { Routes } from "@/router";

@Component({
  components: {
    ActionTile,
  },
})
export default class MyDocumentsTile extends Vue {
  navigateToMyDocuments(): Promise<Route> {
    return router.push({ name: Routes.MyDocuments });
  }
}
